import React from 'react';
import PropTypes from 'prop-types';
import {Descriptions, Typography} from 'antd';
import _ from 'lodash';

import {AppTagTag, DepartTag, TagTag, UserTag} from '@/component';

import allowStyles from '@/page/admin/AppsPage/AppInfo.module.less';

GlobalAllowsView.propTypes = {
    showEmpty: PropTypes.bool,
    allowObj: PropTypes.shape({
        departs: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
            })
        ),
        users: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
            })
        ),
        tags: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
            })
        ),
        adtags: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
            })
        ),
    }),
};

function GlobalAllowsView({allowObj, showEmpty = true}) {
    function renderAllow(label, allows, AllowTag) {
        const empty = _.isEmpty(allows);
        if (!showEmpty && empty) {
            return null;
        }
        return (
            <Descriptions.Item label={label} labelStyle={{alignItems: 'center', width: 100}}>
                <div className={allowStyles.tags}>
                    {empty ? (
                        <Typography.Text type="secondary">未定义</Typography.Text>
                    ) : (
                        allows.map(({id, name}) => (
                            <AllowTag key={id} className={allowStyles.tag}>
                                {name}
                            </AllowTag>
                        ))
                    )}
                </div>
            </Descriptions.Item>
        );
    }

    const {departs, users, tags, adtags} = allowObj || {};

    return (
        <Descriptions column={1}>
            {renderAllow('可见部门', departs, DepartTag)}
            {renderAllow('可见员工', users, UserTag)}
            {renderAllow('可见标签', tags, TagTag)}
            {renderAllow('AD 标签', adtags, AppTagTag)}
        </Descriptions>
    );
}

export default GlobalAllowsView;
